export enum FilesTableEnum {
  Personal = 'personal',
  Received = 'received',
  Shared = 'shared',
  Favorites = 'favorites',
  Recent = 'recent',
  Hidden = 'hidden',
  Trash = 'trash',
}
